import { useMemo } from 'react';

import { Dimensions } from 'components/insights/constants';
import AnalyticsResponseData from 'components/insights/query/AnalyticsResponseData';
import DataTable from 'components/shared/DataTable';

import { buildInboundColumns, buildInboundRows, InboundEntityCellRenderer } from './inboundReferralDetailsColumns';

type Props = {
  loading: boolean;
  data: AnalyticsResponseData;
  entityHeader: string;
  dimension?: Dimensions;
  entityCell?: InboundEntityCellRenderer;
};

const DEFAULT_SORT = [{ id: 'referrals', desc: true }];

export default function InboundReferralDetailsTable({ loading, data, entityHeader, dimension, entityCell }: Props) {
  // While loading (first open, or a View By switch under keepPreviousData) show no rows, so DataTable
  // renders its height-preserving loading placeholder rather than the retained previous View By's
  // rows — this table's data genuinely changes per View By.
  const rows = useMemo(() => (loading ? [] : buildInboundRows(data, dimension)), [loading, data, dimension]);
  const columns = useMemo(() => buildInboundColumns(entityHeader, entityCell), [entityHeader, entityCell]);

  return (
    <DataTable
      columns={columns}
      data={rows}
      defaultSortBy={DEFAULT_SORT}
      loading={loading}
      hasFooter={false}
      maxHeight='520px'
      freezeFirstColumn
    />
  );
}
